var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgGoogleLoginIconLite = function SvgGoogleLoginIconLite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 19.5,
    fill: "#fff",
    stroke: "#E7E7E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 24.278c0-1.028-.085-1.778-.27-2.556H24.256v4.639h7.03c-.142 1.153-.907 2.889-2.608 4.055l-.024.156 3.787 2.874.262.026c2.41-2.18 3.798-5.389 3.798-9.194",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.255 36.5c3.444 0 6.335-1.11 8.447-3.027l-4.025-3.056c-1.077.736-2.523 1.25-4.422 1.25A7.664 7.664 0 0117 26.473l-.15.012-3.937 2.986-.051.14c2.097 4.084 6.405 6.89 11.394 6.89z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.999 26.473A7.555 7.555 0 0116.574 24c0-.86.155-1.694.41-2.472l-.007-.165-3.986-3.034-.13.06A12.308 12.308 0 0011.5 24c0 2.014.496 3.917 1.36 5.611L17 26.474",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.255 16.333c2.395 0 4.01 1.014 4.932 1.861l3.6-3.444c-2.21-2.014-5.088-3.25-8.532-3.25-4.988 0-9.297 2.806-11.394 6.889l4.124 3.139c1.034-3.014 3.897-5.195 7.27-5.195",
    fill: "#EB4335"
  })));
};
export default SvgGoogleLoginIconLite;